import { render } from "./MultiplayerGameIntegration.vue?vue&type=template&id=1fc7102a&scoped=true"
import script from "./MultiplayerGameIntegration.vue?vue&type=script&lang=js"
export * from "./MultiplayerGameIntegration.vue?vue&type=script&lang=js"

import "./MultiplayerGameIntegration.vue?vue&type=style&index=0&id=1fc7102a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc7102a"]])

export default __exports__